import React, { memo } from "react"
import { Badge, Box, Button, Flex, HStack, Skeleton, Stack, Text } from "@chakra-ui/react"
import { useClickAndCollectContext } from "@providers/clickAndCollect"
import TextButton from "@components/TextButton"
import useDeliveryMethod from "@hooks/useDeliveryMethod"
import Icon from "../Icon"

export interface LocationCardProps {
  // setStoreSelected: (store: NormalisedStore | undefined) => void
  setShowClickAndCollect: (arg: boolean) => void
  setViewStore: (store: NormalisedStore | null) => void
}

const ProductLocationCard = ({ setShowClickAndCollect, setViewStore, cartQuantity }: LocationCardProps) => {
  const { setHomeDelivery, deliveryMethod } = useDeliveryMethod()
  const { selected, activeStore, getBadgeProps, loadingLocations, productSkus } = useClickAndCollectContext()

  const correctProduct = React.useMemo(() => {
    const ret = Object.keys(activeStore?.items || {}).find(key => {
      return productSkus?.includes?.(key)
    })
    return ret
  }, [activeStore, productSkus])

  const badgeProps = React.useMemo(() => {
    return activeStore && getBadgeProps(activeStore, false)
  }, [activeStore, getBadgeProps])

  if (!selected) {
    return
  }

  if (loadingLocations || !correctProduct) {
    return <Skeleton mt={2} height="145px" width={"100%"}></Skeleton>
  }

  return deliveryMethod !== "HomeDelivery" && cartQuantity && activeStore ? (
    <Box>
      <Flex alignItems={`center`} justifyContent={`space-between`} mb={2}>
        <Text>Collecting from:</Text>
        <Button onClick={setHomeDelivery} variant={`outline`} size={`sm`} letterSpacing={0}>
          Switch to delivery
        </Button>
      </Flex>
      <HStack
        justifyContent="space-between"
        alignItems="stretch"
        spacing={[0.5, 3]}
        p={[2, 1.5]}
        border="1px solid"
        borderColor={"brand.navy.light"}
        borderRadius="xs"
        height={"auto"}
        gap={2}
      >
        {/* <pre>{JSON.stringify(activeStore, null, 2)}</pre> */}
        <Stack>
          <Badge size="sm" w="fit-content" variant={badgeProps?.variant} color={badgeProps?.variant === "warning" ? `black` : `white`}>
            <Icon name={badgeProps?.icon} size="16px" mr={0.5} color={badgeProps?.variant === "warning" ? `black` : `white`} />
            {badgeProps?.label}
          </Badge>
          <Stack spacing={0.5}>
            <Text size="lg" fontWeight="semibold">
              {activeStore.name}
            </Text>
            <Text size="xs">{activeStore?.address}</Text>
          </Stack>
        </Stack>
        <Stack justifyContent="space-between" alignItems="flex-end" minW={"fit-content"}>
          <Button variant={"navy"} size="sm" w="fit-content" onClick={setHomeDelivery}>
            {"Selected"}
          </Button>
          <TextButton
            size="sm"
            icon="chevronRight"
            onClick={() => {
              setViewStore(activeStore)
              setShowClickAndCollect(true)
            }}
          >
            Store Details
          </TextButton>
        </Stack>
      </HStack>
    </Box>
  ) : null
}

export default memo(ProductLocationCard)
